import { Pipe, PipeTransform } from '@angular/core';

import { Quote } from '../model/quote';

@Pipe({
    name: 'quoteApprovalSearchPipe'
})
export class QuoteApprovalSearchPipe implements PipeTransform {

    constructor() { }

    transform(value: Quote[], searchTerm: KeyboardEvent) {
        let filteredQuotes;
        if (value && searchTerm) {
            if (value.filter(x => (x.quoteId !== undefined && x.quoteId !== null && x.quoteId.toString().toLowerCase().includes(searchTerm.target['value'].toLowerCase()))
                || (x.customer !== undefined && x.customer !== null && x.customer.toLowerCase().includes(searchTerm.target['value'].toLowerCase()))
                || (x.retailerName !== undefined && x.retailerName !== null && x.retailerName.toLowerCase().includes(searchTerm.target['value'].toLowerCase()))
                || (x.mdm !== undefined && x.mdm !== null && x.mdm.toLowerCase().includes(searchTerm.target['value'].toLowerCase()))
                || (x.plantName !== undefined && x.plantName !== null && x.plantName.toLowerCase().includes(searchTerm.target['value'].toLowerCase()))
                || (x.modelDesc !== undefined && x.modelDesc !== null && x.modelDesc.toLowerCase().includes(searchTerm.target['value'].toLowerCase()))
            ).length > 0) {
                filteredQuotes = value.filter(x => (x.quoteId !== undefined && x.quoteId !== null && x.quoteId.toString().toLowerCase().includes(searchTerm.target['value'].toLowerCase()))
                    || (x.customer !== undefined && x.customer !== null && x.customer.toLowerCase().includes(searchTerm.target['value'].toLowerCase()))
                    || (x.retailerName !== undefined && x.retailerName !== null && x.retailerName.toLowerCase().includes(searchTerm.target['value'].toLowerCase()))
                    || (x.mdm !== undefined && x.mdm !== null && x.mdm.toLowerCase().includes(searchTerm.target['value'].toLowerCase()))
                    || (x.plantName !== undefined && x.plantName !== null && x.plantName.toLowerCase().includes(searchTerm.target['value'].toLowerCase()))
                    || (x.modelDesc !== undefined && x.modelDesc !== null && x.modelDesc.toLowerCase().includes(searchTerm.target['value'].toLowerCase()))
                );
            } else {
                filteredQuotes = [{ noMatches: true, message: 'No matches found.' }];
            }

            return filteredQuotes;
        } else {
            return value;
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/pipes/quote-approval-search.pipe.ts